/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_Filesizelimittitle3Inputs */

const zh_upload_filesizelimittitle3 = /** @type {(inputs: Upload_Filesizelimittitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件过大`)
};

const en_upload_filesizelimittitle3 = /** @type {(inputs: Upload_Filesizelimittitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File too large`)
};

const es_upload_filesizelimittitle3 = /** @type {(inputs: Upload_Filesizelimittitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivo demasiado grande`)
};

/**
* | output |
* | --- |
* | "File too large" |
*
* @param {Upload_Filesizelimittitle3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const upload_filesizelimittitle3 = /** @type {((inputs?: Upload_Filesizelimittitle3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_Filesizelimittitle3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_upload_filesizelimittitle3(inputs)
	if (locale === "en") return en_upload_filesizelimittitle3(inputs)
	return es_upload_filesizelimittitle3(inputs)
});
export { upload_filesizelimittitle3 as "upload_fileSizeLimitTitle" }